const part = [
    {
        path: 'pay-management-list',
        name: 'pay-management-list',
        meta: {
            icon: 'md-people',
            title: '支付管理',
            notCache: true,
            access: ['S'],
            items: [
            ]
        },
        component: () => import('@/view/system-management/pay-management/pay-list')
    }
];

export default part;